import axios from 'axios';

export const setCorrelationIdHeader = (id: string) => {
  axios.defaults.headers.common['Nib-CorrelationId'] = id;
};
